<template>
  <div class="loginContainer">
    <div class="inner_div">
      <el-row>
        <el-col :span="12" class="col-background1">
        </el-col>
        <el-col :span="12" class="col-background2">
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" @submit.native.prevent>
            <div class="titile">
              <h1>
                登录账号
              </h1>
            </div>

            <el-form-item prop="username">
              <el-input placeholder="账户" class="inputItem" type="text" v-model="ruleForm.username">
                <i slot="prefix" class="el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input placeholder="密码" class="inputItem" type="password" show-password v-model="ruleForm.password">
                <i slot="prefix" class="el-icon-key"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="submiButton" type="primary" native-type="submit" :loading="login.click" @click="submitForm('ruleForm')">{{login.text}}</el-button>
            </el-form-item>
          </el-form>
          <span class="company">Copyright © 2009-2029 光</span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { login,sendMsgU } from "@/api/index";
  import md5 from 'js-md5';

  export default {
    data() {
      var validatePassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          callback();
        }
      };
      return {
        login:{
          click: false,
          text: '登 录'
        },
        code:{
          member: 'user',
          btnText: '发送验证码',
          loading: false
        },
        ruleForm: {
          username: '',
          password: '',
          code: ''
        },
        rules: {
          username: [
            { required: true, message:'请输入账号', trigger: 'blur' },
            { min: 5, max: 15, message:'长度必须5-15个字符', trigger: 'blur'}
          ],
          password: [
            { validator: validatePassword, trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.login.click = true
            this.login.text = '正 在 登 录'
            const loading = this.$loading({
              lock: true,
              text: '正在登录...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            login({
              username: this.ruleForm.username,
              password: md5(this.ruleForm.password)
            }).then(res => {
              loading.close();
              this.login.click = false
              if (res.success == true) {
                this.setSessionStore("accessToken", res.result.token)
                this.$store.commit("curPage", "0")
                this.$store.commit("SAVA_USERINFO", res.result.user)
                this.$message({
                  message: '登录成功',
                  type: 'success'
                })
                this.$router.replace({path: '/index',query:{isfirst: true}})
              }else{
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'error'
                })
              }
            });
          } else {
            return false;
          }
        });
      }
    }
  }
</script>

<style lang="scss">
  .loginContainer{
    height: 100%;
    width: 100%;

    background: url("../assets/login-back-ground.png") no-repeat center center;
    background-size: 100% 100%;
    text-align: center;

    .inner_div{
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -300px;
      margin-left: -550px;
      width: 1100px;
      height: 600px;
      background: url("../assets/login-back-ground_accessories.png") no-repeat center center;
      background-size: 100% 100%;
    }

    body{
      margin: 0px;
      overflow:hidden;
    }

    .el-row{
      height: 100%;
    }
    .col-background1{
      height: 100%;
    }

    .col-background2{
      /*background-color: white;*/
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .titile{
      /*position: relative;*/
      /*bottom: 50px;*/
      padding-bottom: 40px;
    }
    .titile h1{
      font-size: 30px;
      color: #0088F4;
      margin: 0;
      font-weight: bold;
    }

    .submiButton{
      width: 380px;
      border-radius: 10px;
      padding-right: 40px;
      margin-top: 10px;
      -webkit-box-shadow:0px 3px 3px #c8c8c8;
      -moz-box-shadow:0px 3px 3px #c8c8c8;
      box-shadow:0px 3px 3px #c8c8c8;
    }

    .inputItem{
      width: 380px;
      margin-top: 8px;
    }
    .company{
      position: absolute;
      bottom: 20px;
      right: 20px;
      font-size: 10px;
      color: #666666;
    }
  }
</style>
